import { useSelector } from 'react-redux';

/**
 * Hook centralisé pour vérifier si l'utilisateur connecté est Super Admin.
 * Le Super Admin a le profil exactement égal à 'ADMIN'.
 * Les autres profils (ADMIN-PRODUCTION, ADMIN-BILLETTERIE, etc.) ne sont PAS super admin.
 *
 * @returns {boolean} true si l'utilisateur est Super Admin
 */
const useIsAdmin = () => {
    const { me } = useSelector((state) => state.me);
    return me?.profil === 'ADMIN';
};

export default useIsAdmin;
